function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .BuscarIcon-1 {\r\n        fill: #0098dc;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "lCPIy2.tif"
}, /*#__PURE__*/React.createElement("path", {
  className: "BuscarIcon-1",
  d: "M18.2,21c-.1,0-.3,0-.4-.1-.4-.1-.7-.3-1-.6-1.6-1.6-3.3-3.3-4.9-4.9-.4-.4-.4-.9,0-1.3.2-.2.3-.3.5-.5-.4-.4-.8-.8-1.2-1.2-.6.5-1.3.9-2.1,1.1C5.1,14.8.9,12.3.1,8.2,0,7.9,0,7.7,0,7.4c0-.3,0-.7,0-1,0-.4.1-.8.2-1.1C.8,2.7,3.1.6,5.7.1c3.6-.6,7,1.6,7.9,5.1.5,2.1.2,4.1-1.1,5.9,0,0,0,.1-.1.1.4.4.8.8,1.2,1.2.1-.2.3-.4.5-.5.4-.4.9-.4,1.2,0,1.6,1.6,3.3,3.3,4.9,4.9,1,1,1,2.7-.1,3.6-.3.3-.7.5-1.2.5,0,0,0,0-.1,0h-.6ZM6.9,12.2c2.9,0,5.3-2.4,5.3-5.3,0-2.9-2.4-5.3-5.3-5.3-2.9,0-5.3,2.4-5.3,5.3,0,2.9,2.4,5.3,5.3,5.3ZM13.6,14.8s0,0,0,0c1.4,1.4,2.8,2.8,4.2,4.2,0,0,0,0,.1,0,.5.4,1.2.2,1.3-.4,0-.3,0-.6-.3-.8-1.4-1.4-2.8-2.8-4.2-4.2,0,0,0,0-.1,0-.4.4-.8.8-1.2,1.1Z"
}));

var SvgBuscar = function SvgBuscar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BuscarIcon",
    "data-name": "Layer 1",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuscar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Buscar.7abcc517.svg";
export { ForwardRef as ReactComponent };